import * as angular from "angular";
import { OrganisationInvite } from "../models/organisation-invite.model";
import { OrganisationInviteService } from "../services/organisation-invite.service";

export class OrganisationInviteDataProvider {
    private $q: any;
    private $timeout: any;
    private service: OrganisationInviteService;
    private modelsUtils: any;

    public invites: any = null;

    constructor(
        $q: any,
        $timeout: any,
        ModelsUtils: any,
        OrganisationInviteService: OrganisationInviteService
    ) {
        this.$q = $q;
        this.service = OrganisationInviteService;
        this.$timeout = $timeout;
        this.modelsUtils = ModelsUtils;
    }

    /**
     * returns all organisation invites
     */
    getAllInvites(oid: string | number): Promise<any> {
        const deferred = this.$q.defer();
        if (this.invites === null) {
            this.service.all({ id: oid }).then(
                (response) => {
                    let json = response["data"];
                    this.invites = [];
                    for (let i = 0; i < json.data.length; i++) {
                        this.invites.push(
                            this.modelsUtils.organisationInvite(json.data[i])
                        );
                    }
                    deferred.resolve(this.invites);
                },
                (error) => {
                    this.invites = [];
                    deferred.reject(error);
                }
            );
        } else {
            deferred.resolve(this.invites);
        }
        return deferred.promise;
    }

    resend(invite: OrganisationInvite): Promise<any> {
        const deferred = this.$q.defer();
        this.service.resend(invite).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    clearAll() {
        this.invites = null;
    }

    inviteWithID(id: string | number): OrganisationInvite {
        let existingInvite = null;
        angular.forEach(this.invites, (invite) => {
            if (invite.tpid == id) {
                existingInvite = invite;
            }
        });

        if (existingInvite) {
            return existingInvite;
        } else {
            return null;
        }
    }

    inviteWithEmail(email: string): boolean {
        let existingInvite = null;
        angular.forEach(this.invites, (invite) => {
            if (invite.organisationinviteemail == email) {
                existingInvite = true;
            }
        });

        if (existingInvite) {
            return existingInvite;
        } else {
            return false;
        }
    }

    spliceInvite(invite: OrganisationInvite) {
        //Remove Invite from list
        let invitesIndex = this.invites.indexOf(invite);
        if (invitesIndex > -1) {
            this.invites.splice(invitesIndex, 1);
        }
    }

    deleteInvite(invite: OrganisationInvite): Promise<any> {
        const deferred = this.$q.defer();
        this.service
            .delete({ id: invite.organisationinviteid })
            .then((response) => {
                let json = response["data"];
                if (json.success) {
                    this.spliceInvite(invite);
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            });

        return deferred.promise;
    }

    replaceInvite(invite: OrganisationInvite) {
        this.$timeout(() => {
            let existingInvite = this.inviteWithEmail(
                invite.organisationinviteemail
            );
            if (!existingInvite) {
                this.invites.unshift(invite);
            }
        });
    }

    processSocketCreate(socketData: any) {
        if (this.invites) {
            this.replaceInvite(this.modelsUtils.organisationInvite(socketData));
        }
    }

    processSocketDelete(socketData: any) {
        if (this.invites) {
            let existingInvite = this.inviteWithID(
                socketData.organisationinviteid
            );
            if (existingInvite) {
                this.spliceInvite(existingInvite);
            }
        }
    }
}

angular
    .module("vcDataProvider")
    .service("OrganisationInviteDataProvider", OrganisationInviteDataProvider);
